import React from 'react';
import UnauthorisedAlertCardView from '../../components/UnauthorisedAlertCardView';
import iconMab from '../../assets/icons/icon_mab.svg';
import i18n from '../../utils/i18n';

function redirectToGoogleSSO() {
  const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_OAUTH_REDIRECT_URI;

  if (!clientId || !redirectUri) {
    throw new Error('OAuth environment variables are not configured');
  }

  window.location.href = `https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=openid email`;
}

const UnauthorisedView: React.FC = () => (
  <div className="flex flex-col w-screen h-screen items-center justify-center" data-testId="unauthorised-view">
    <UnauthorisedAlertCardView
      icon={iconMab}
      header={i18n.t('unauthorised.header')}
      title={i18n.t('unauthorised.title')}
      subtitle={i18n.t('unauthorised.subtitle')}
      loginButton={i18n.t('unauthorised.loginButton')}
      helpButton={i18n.t('unauthorised.helpButton')}
      clickHandler={() => {
        redirectToGoogleSSO();
      }}
    />
  </div>
);
export default UnauthorisedView;
